import { configureStore } from "@reduxjs/toolkit";
import AdminSlice from "../FunctionComponents/Redux/AdminSlice";
import searchSlice from "../FunctionComponents/Redux/SearchSlice"

export default configureStore({
 reducer: {
  admin: AdminSlice,
  search: searchSlice
 },
});
